// Initialize DataDog
import { datadogLogs, LogsInitConfiguration } from '@datadog/browser-logs';
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { User } from './store/User';

const initializeDataDog = () => {
  const {
    REACT_APP_DATADOG_CLIENT_TOKEN,
    REACT_APP_DATADOG_RUM_APP_ID,
    REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
    REACT_APP_DATADOG_SITE,
    REACT_APP_DATADOG_ENV
  } = process.env;

  if (REACT_APP_DATADOG_CLIENT_TOKEN && REACT_APP_DATADOG_SITE) {
    datadogLogs.init({
      clientToken: REACT_APP_DATADOG_CLIENT_TOKEN as LogsInitConfiguration['clientToken'],
      site: REACT_APP_DATADOG_SITE as LogsInitConfiguration['site'],
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      service: 'upstack-tally',
      env: REACT_APP_DATADOG_ENV as LogsInitConfiguration['env']
    });
  }

  if (REACT_APP_DATADOG_RUM_APP_ID && REACT_APP_DATADOG_RUM_CLIENT_TOKEN && REACT_APP_DATADOG_SITE) {
    datadogRum.init({
      applicationId: REACT_APP_DATADOG_RUM_APP_ID as RumInitConfiguration['applicationId'],
      clientToken: REACT_APP_DATADOG_RUM_CLIENT_TOKEN as RumInitConfiguration['clientToken'],
      site: REACT_APP_DATADOG_SITE as RumInitConfiguration['site'],
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      service: 'upstack-tally',
      defaultPrivacyLevel: 'mask-user-input',
      env: REACT_APP_DATADOG_ENV as RumInitConfiguration['env']
    });

    datadogRum.startSessionReplayRecording();
  }
};

export default initializeDataDog;
export const setDataDogUser = (user: User) => {
  datadogRum.setUser({
    id: user.id,
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    role: user.role,
    first_name: user.firstName,
    last_name: user.lastName
  });
};
